import React from "react";
import { Link } from "react-router-dom";
import "./AboutPage.css";

// About Icons
function EyeIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );
}

function HeartIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

function StarIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/>
    </svg>
  );
}

function ShieldIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}

function PaletteIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="13.5" cy="6.5" r=".5"/>
      <circle cx="17.5" cy="10.5" r=".5"/>
      <circle cx="8.5" cy="7.5" r=".5"/>
      <circle cx="6.5" cy="12.5" r=".5"/>
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
    </svg>
  );
}

function CheckCircleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22,4 12,14.01 9,11.01"/>
    </svg>
  );
}

function UsersIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  );
}

function AwardIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="6"/>
      <polyline points="12,14 12,22 8,20"/>
      <polyline points="12,14 12,22 16,20"/>
    </svg>
  );
}

export default function AboutPage() {
  return (
    <div className="mariamly-about-page">
      {/* Banner Section */}
      <div className="about-banner">
        <div className="about-banner-content">
          <h1 className="about-banner-title">About Us</h1>
          <div className="about-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>About Us</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="about-content">
        {/* Introduction Section */}
        <div className="about-intro">
          <div className="intro-content">
            <h2>About Us – Mariamly Luxe</h2>
            <p className="intro-lead">
              Welcome to Mariamly Luxe, your online destination for luxury beauty. We are more than just a cosmetics website—we are a curated world of makeup, skincare, and haircare designed to help you look and feel your absolute best.
            </p>
          </div>
          <div className="intro-image">
            <div className="image-placeholder">
              <PaletteIcon size={48} color="#d19e90" />
            </div>
          </div>
        </div>

        {/* Vision Section */}
        <div className="vision-section">
          <div className="vision-content">
            <div className="vision-icon">
              <EyeIcon size={40} />
            </div>
            <h3>Our Vision</h3>
            <p>
              At Mariamly Luxe, we believe that beauty is a lifestyle, not a trend. Our vision is to bring premium beauty products right to your fingertips, making it simple and effortless to indulge in self-care and elegance every day.
            </p>
          </div>
        </div>

        {/* What We Offer */}
        <div className="offerings-section">
          <h3>What We Offer</h3>
          <p className="offerings-intro">
            Our website brings together a wide range of carefully selected cosmetics, including:
          </p>
          <div className="offerings-grid">
            <div className="offering-card">
              <div className="offering-icon">
                <PaletteIcon size={32} />
              </div>
              <h4>Makeup</h4>
              <p>Makeup that enhances your natural features and inspires creativity. From everyday essentials to statement pieces for special occasions.</p>
            </div>
            <div className="offering-card">
              <div className="offering-icon">
                <HeartIcon size={32} />
              </div>
              <h4>Skincare</h4>
              <p>Skincare that nourishes, protects, and revitalizes your skin. Premium products for every skin type and concern.</p>
            </div>
            <div className="offering-card">
              <div className="offering-icon">
                <StarIcon size={32} />
              </div>
              <h4>Haircare</h4>
              <p>Haircare that restores strength, shine, and confidence. Professional-grade products for healthy, beautiful hair.</p>
            </div>
          </div>
          <p className="offerings-conclusion">
            Whether you are building your daily essentials or searching for statement beauty products, Mariamly Luxe offers everything you need in one place.
          </p>
        </div>

        {/* Why Choose Us */}
        <div className="why-choose-section">
          <h3>Why Choose Us</h3>
          <div className="reasons-grid">
            <div className="reason-card">
              <div className="reason-icon">
                <ShieldIcon size={40} />
              </div>
              <h4>Trusted Quality</h4>
              <p>We are dedicated to offering trusted, high-quality, and luxurious products that meet the highest standards.</p>
            </div>
            <div className="reason-card">
              <div className="reason-icon">
                <CheckCircleIcon size={40} />
              </div>
              <h4>Carefully Selected</h4>
              <p>Every product featured on Mariamly Luxe is chosen with care, ensuring safety, performance, and elegance for our customers.</p>
            </div>
            <div className="reason-card">
              <div className="reason-icon">
                <UsersIcon size={40} />
              </div>
              <h4>Customer Focused</h4>
              <p>We prioritize our customers' needs and satisfaction, providing personalized service and expert recommendations.</p>
            </div>
            <div className="reason-card">
              <div className="reason-icon">
                <AwardIcon size={40} />
              </div>
              <h4>Excellence</h4>
              <p>We maintain the highest standards in product selection, customer service, and overall shopping experience.</p>
            </div>
          </div>
        </div>

        {/* Our Promise */}
        <div className="promise-section">
          <div className="promise-content">
            <h3>Our Promise</h3>
            <p>
              Shopping with Mariamly Luxe means choosing quality, luxury, and convenience. Our promise is to bring you not only the finest beauty products but also an inspiring and enjoyable shopping experience.
            </p>
            <div className="promise-features">
              <div className="promise-feature">
                <CheckCircleIcon size={24} />
                <span>Premium product quality</span>
              </div>
              <div className="promise-feature">
                <CheckCircleIcon size={24} />
                <span>Secure and fast delivery</span>
              </div>
              <div className="promise-feature">
                <CheckCircleIcon size={24} />
                <span>Expert customer support</span>
              </div>
              <div className="promise-feature">
                <CheckCircleIcon size={24} />
                <span>Authentic products guaranteed</span>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="cta-section">
          <div className="cta-content">
            <h3>Ready to Experience Luxury Beauty?</h3>
            <p>
              Discover our curated collection of premium beauty products and join thousands of satisfied customers who trust Mariamly Luxe for their beauty needs.
            </p>
            <div className="cta-buttons">
              <Link to="/shop" className="cta-button primary">
                <StarIcon size={20} />
                <span>Shop Now</span>
              </Link>
              <Link to="/contact" className="cta-button secondary">
                <UsersIcon size={20} />
                <span>Contact Us</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
